export default __webpack_public_path__ + "static/media/adjustment.4d09317f.png";